import React, { FunctionComponent } from "react";
import { validateIntegerInRange } from "$src/util/validations";
import { IBaseNumberField, NumberField } from "../index";

export const PositiveIntegerField: FunctionComponent<IBaseNumberField> = props => (
  <NumberField
    {...props}
    validator={validateIntegerInRange({ min: { value: 0, include: false } })}
  />
);
